module.exports = __webpack_public_path__ + "static/media/no-package.4a532a7b.svg";